import {createBrowserHistory,createHashHistory} from 'history';

export const history = createHashHistory();